export default "__VITE_ASSET__B910hQRp__"